var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 160,
    viewBox: "0 0 87 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9108 25.3422C58.1014 25.3422 63.9305 19.6692 63.9305 12.6711C63.9305 5.67305 58.1014 0 50.9108 0C43.7202 0 37.8911 5.67305 37.8911 12.6711C37.8911 19.6692 43.7202 25.3422 50.9108 25.3422Z",
    fill: "#081754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8728 74.2808L82.7846 82.9543L86.9596 76.078L61.6621 60.0438L58.9066 50.4358C57.8479 46.5465 56.4511 42.7519 54.7315 39.093C53.3777 36.0179 51.0506 33.4436 48.0889 31.7453C45.1273 30.0469 41.6858 29.313 38.2658 29.6506C30.7027 31.639 23.434 34.5667 16.6391 38.3616L0 47.5915V84.314H7.59214L9.6347 56.1556L20.8077 49.695L15.5986 66.0074C14.651 68.9766 13.9676 72.0197 13.556 75.1029V75.1029C12.8309 80.5362 12.9391 86.0442 13.8772 91.4465L14.6833 96.7819L0.382176 156.437L10.6592 160L32.1157 106.506L35.6227 109.753C41.2748 114.988 45.4203 121.572 47.6468 128.85L56.9411 159.215L67.1346 156.206L60.1655 116.329C58.9806 112.202 57.2718 108.234 55.0784 104.518L43.8026 85.4142L49.9045 65.0072C53.5 68.9613 57.9213 72.123 62.8728 74.2808V74.2808Z",
    fill: "#081754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalk);
export default __webpack_public_path__ + "static/media/walk.c7d48b6f2195fceeaa8e6ed82972766b.svg";
export { ForwardRef as ReactComponent };